import { useState, useEffect } from "react";
import { ToastMessage } from "../../../../global/ToastMessage";
import { DialogMessage } from "../../../../global/DialogMessage";
import { FCorteStyleStyle, FCorteButonStyleStyle } from "./FCorteStyle";
import { Button, Grid, Typography, TextField } from "@material-ui/core";
import { useDispatch } from "react-redux";
import HeaderModal from "../../../../global/headerModal";
import ModalBase from "./../../../../global/ModalBase";
import { useSelector } from "react-redux";
import { formatDinero } from "./../../../../utils/formatDinero"
import { nuevoCorteCaja, obtenerMovientosUSDAction } from "./../../../../ducks/finanzasDuck"
import { offLoadAction, onLoadAnction } from "./../../../../ducks/loadDuck"
import * as yup from "yup";
import { useFormik, getIn } from "formik";

const validationSchema = yup.object({
    tipoCambio: yup.number("Ingresa tipo de cambio valido").required("Tipo de cambio es requerido"),
});

const InitalValues = {
    tipoCambio: 1,
};

const BCorte = ({ disabled = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleOpen = () => {
        setIsOpen(!isOpen)
    }
    const classButton = FCorteButonStyleStyle();
    return (
        <div className={classButton.flexEnd}>
            <Button variant="outlined" color="primary" onClick={handleOpen} disabled={disabled}>
                Marcar Compra
            </Button>
            <FCorte open={isOpen} setOpen={handleOpen} />
        </div>
    );
};

const FCorte = ({ open = true, setOpen = () => { } }) => {
    const movimientosUSD = useSelector(store => store.finanzas.movimientosCuenta)
    const { movimientoFechaIni, movimeintoFechaFin } = useSelector(store => store.finanzas)
    const rows = movimientosUSD?.MovimientosCuenta ?? []
    const dispatch = useDispatch();
    const classes = FCorteStyleStyle();
    const [total, setTotal] = useState(0)
    const formik = useFormik({
        initialValues: InitalValues,
        validationSchema: validationSchema,
        onSubmit: (values) => onSave(values)
    })
    const onSave = (values) => {
        if (Number(values.tipoCambio) <= 1) {
            ToastMessage.fire({
                icon: "info",
                title: "Dato no valido",
                text: "El tipo de cambio debe ser mayor a 1"
            })
            return null
        }
        DialogMessage.fire({
            title: '¿Estas seguro de aplicar es corte de caja?',
            html: `Ingreso Total MXN: ${formatDinero(movimientosUSD.TotalMXN)}
            </br> Tipo de cambio: <b>${formatDinero(values.tipoCambio)}</b>
            </br> Total de moviemientos: ${rows.length}
            </br> Total con T.C: ${formatDinero(total)}`,
            showCancelButton: true,
            confirmButtonText: "Aplicar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({message: "Procesando"}))
                dispatch(nuevoCorteCaja({ TipoCambio: values.tipoCambio })).then((Response) => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha ocurrido un error, por favor inténtelo de nuevo más tarde",
                        })
                        return null
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        })
                        return null
                    }
                    dispatch(obtenerMovientosUSDAction({ FechaInicio: movimientoFechaIni, FechaFinal: movimeintoFechaFin }))
                    handleClose();
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                })
            }
        })
    }
    const LimpiarForm = () => {
        formik.resetForm(InitalValues);
    };
    const handleClose = () => {
        setOpen();
        LimpiarForm();
    };

    const Valor = getIn(formik.values, "tipoCambio");

    useEffect(() => {
        setTotal(movimientosUSD.TotalMXN / Valor)
    }, [Valor, movimientosUSD.TotalMXN]);

    return (
        <ModalBase classes={classes} open={open} onClose={handleClose}>
            <HeaderModal handleClose={handleClose} titulo={`Corte de Caja`} />
            <form onSubmit={formik.handleSubmit}>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography>Ingreso Total MXN: <b>{formatDinero(movimientosUSD.TotalMXN)}</b></Typography>
                        <Typography>Total Movimientos: <b>{rows.length}</b></Typography>
                        <Typography>Total con T.C: <b>{formatDinero(total)}</b></Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            required
                            id="input-tipoCambio"
                            label="Tasa de Cambio"
                            type="text"
                            variant="outlined"
                            name="tipoCambio"
                            value={formik.values.tipoCambio}
                            onChange={formik.handleChange}
                            error={formik.touched.tipoCambio && Boolean(formik.errors.tipoCambio)}
                            helperText={formik.touched.tipoCambio && formik.errors.tipoCambio}
                            className={classes.textField}
                        />
                    </Grid>
                </Grid>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12} className={classes.modalBotonesCenter}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.modalBoton}
                        >
                            {"Aplicar"}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </ModalBase>
    );
};
export default BCorte;
